import React from 'react';
import PropTypes from 'prop-types';

const CSF = ({ searchTerm, isDarkMode }) => {
  const csfValues = {
    general: [
      {
        test: 'Cell Count',
        conventional: '0–5/mm³',
        si: '0–5 × 10⁶/L'
      },
      {
        test: 'Chloride',
        conventional: '118–132 mEq/L',
        si: '118–132 mmol/L'
      },
      {
        test: 'Gamma Globulin',
        conventional: '3%–12% of total proteins',
        si: '0.03–0.12'
      },
      {
        test: 'Glucose',
        conventional: '40–70 mg/dL',
        si: '2.2–3.9 mmol/L'
      },
      {
        test: 'Pressure',
        conventional: '70–180 mm H₂O',
        si: '70–180 mm H₂O'
      },
      {
        test: 'Proteins, Total',
        conventional: '<40 mg/dL',
        si: '<0.40 g/L'
      }
    ]
  };

  const filterData = (data, term) => {
    if (!term) return data;
    const lowerTerm = term.toLowerCase();
    
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = data[key].filter(item => 
        item.test.toLowerCase().includes(lowerTerm) ||
        (typeof item.conventional === 'string' && 
         item.conventional.toLowerCase().includes(lowerTerm)) ||
        (typeof item.si === 'string' && 
         item.si.toLowerCase().includes(lowerTerm))
      );
      return acc;
    }, {});
  };

  const filteredValues = filterData(csfValues, searchTerm);

  return (
    <div className={isDarkMode ? 'ext_lbs_dark-mode' : ''}>
      {filteredValues.general.length > 0 && (
        <>
          <h2>Cerebrospinal Fluid (CSF)</h2>
          <div className="ext_lbs_labs-table_container">
            <table className="ext_lbs_labs-table">
              <thead>
                <tr>
                  <th>Test</th>
                  <th>Conventional Range</th>
                  <th>SI Range</th>
                </tr>
              </thead>
              <tbody>
                {filteredValues.general.map((item, index) => (
                  <tr key={index}>
                    <td>{item.test}</td>
                    <td>{item.conventional}</td>
                    <td>{item.si}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

CSF.propTypes = {
  searchTerm: PropTypes.string,
  isDarkMode: PropTypes.bool
};

export default CSF; 